// https://lincolnprofilev9.cms.dealer.com/2026-lincoln-corsair.htm
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { result, widgetName, widgetIntention } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer' &&
						widgetIntention === 'exterior photos'
					);
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'vehicle:action:exterior:photo click:exterior',
							onclickLinkName:
								'new:si:vls:content:action:lincoln corsair'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln corsair'
						}
					}
				})
			},
			{
				logic: ({ eventData }) => {
					const { result, widgetName, widgetIntention } = eventData;

					return (
						result === 'Opens gallery modal' &&
						widgetName === 'ws-media-viewer' &&
						widgetIntention === 'interior photos'
					);
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'vehicle:action:interior:photo click:interior',
							onclickLinkName:
								'new:si:vls:content:action:lincoln corsair'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln corsair'
						}
					}
				})
			}
		],
		'ddc.link.generic': [
			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'schedule-test-drive'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'vehicle:action:schedule test drive',
							onclickLinkName:
								'vehicle:content:action:2026 lincoln corsair'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln corsair'
						}
					}
				})
			},
			{
				logic: ({ eventData }) =>
					eventData?.attributes?.class?.includes?.(
						'search-inventory'
					),
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'vehicle:action:search inventory',
							onclickLinkName:
								'new:si:vls:content:action:lincoln corsair'
						},
						vehicle: {
							modelYear: '2026',
							nameplate: 'lincoln corsair'
						}
					}
				})
			}
		]
	}
};
